import api from './index'

const resource = 'project_priorities'

export default {
  getPriorities (key, allPriorities) {
    const params = allPriorities ? { all_priorities: true } : { key: key }
    return api.get(resource, { params: params })
  }
}
